import bnc from "bnc";
const block = new bnc('chains-course-card');


export {
    block
};
